import { createContext } from 'react'

export const NewsboardPostProfileContext = createContext()
